export const environment = {
  production: false,
  apiUrl: 'https://charityapi.dev.capium.co.uk/',
  uiUrl: 'https://charity.dev.capium.co.uk',
  appDomain: 'charity.dev',
  stsServerUrl: 'https://account.dev.capium.co.uk',
  identityLoginUrl: 'https://account.dev.capium.co.uk/Account/Login',
  clientId: 'capium_timeandfee_angular',
  cdnUrl: 'https://cdn.dev.capium.co.uk/shared/',
  apiVersionUrl: 'https://charityapi.dev.capium.co.uk/api/v1/',
  apiVersionUrl_V2: 'https://charityapi.dev.capium.co.uk/api/v2/',
  // apiVersionUrl_V2: 'https://localhost:7193/api/v2/',
  // apiVersionUrl: 'https://localhost:7193/api/v1/',
  identityDomain: 'identity.dev',
  platfrom: 'dev',
  domain: 'capium.co.uk',
  helpDeskUrl: 'https://capium.freshdesk.com/support/home',
  subscriptionApiUrl: 'https://storeapi.dev.capium.co.uk/api/v1',
  SyncfusionLicenseKey:
    'Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH9fd3RVQmNcV0d/V0M=',
};
